const axios = require('axios');

export const getPreferencesByEmail = async (email) => {
	let conn = `/api/prefs/${email}`

	let [err, result] = await axios.get(
		conn, {
			headers: { Pragma: 'no-cache' } // don't get result from cache (after save specifically, IE specifically)
		}
	).then(result => [null, result])
	.catch(err => [err, null]);
	if (err)
		return err;
	return result;
}

export const getEmailByToken = async (token) => {
	let conn = `/api/address/${token}`

	let [err, result] = await axios.get(
		conn
	).then(result => [null, result])
	.catch(err => [err, null]);
	if (err)
		return err;
	return result;
}

export const getCategories = async () => {
	let conn = `/api/categories`

	let [err, result] = await axios.get(
		conn
	).then(result => [null, result])
	.catch(err => [err, null]);
	if (err)
		return err;
	return result;
}

export const updatePreferences = async (email, channel, body) => {
  let conn = `/api/prefs/${channel}/${email}`
  const [err, result] = await axios.put(
    conn, body
  ).then(result => [null, result])
  .catch(err => [err, null]);
  if(err)
    return err;
  return await result.data;
}